import { makeStyles } from '@/styles/theme/tss-react';

interface Props {
  spacingLevel: number;
}

const useStyles = makeStyles<Props>({
  name: 'SpacingContainer',
})(({ spacing }, { spacingLevel }) => ({
  container: {
    padding: `${spacing(spacingLevel)} 0`,
  },
}));

export default useStyles;
